module.exports = __webpack_public_path__ + "img/DSC_0793.71fa932c.jpeg";